package kotlinReactComponents

import BaseLayoutStyles
import constants.CompanyConstants.Companion.companySloganString
import react.RBuilder
import styled.css
import styled.styledDiv



fun RBuilder.companySlogan() {
    styledDiv {
        css {
            +BaseLayoutStyles.companySlogan
            }
        styledDiv {
            css {
                +BaseLayoutStyles.blackLetters
                }
//                attrs.text(companySloganString.topLineText)
            +companySloganString.topLineText
        }
        styledDiv {
            css {
                +BaseLayoutStyles.whiteLetters
                }
//                attrs.text(companySloganString.bottomLinesText)
            +companySloganString.bottomLinesText
        }
    }
}
